import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "./ui/tooltip";

export const Tip = ({ label, children, side = "bottom" }) => (
  <TooltipProvider delayDuration={250}>
    <Tooltip>
      <TooltipTrigger asChild>{children}</TooltipTrigger>
      <TooltipContent side={side} className="text-xs max-w-[220px]">{label}</TooltipContent>
    </Tooltip>
  </TooltipProvider>
);
